import React, {cloneElement, useCallback, useEffect, useState} from 'react';
import {t} from 'i18next';
import MediaGallery from '../../../MediaGallery/MediaGallery';
import {AssistantContent} from '../../AssistantContent';
import {AssistantFooter} from '../../AssistantFooter';
import {AssistantHeader} from '../../AssistantHeader';
import {AssistantSubHeader} from '../../AssistantSubHeader';
import {AssistantNav} from '../../AssistantNav';
import {useAssistant} from '../../../Context/Assistant/AssistantContext';
import {AssistantActions} from '../../../Context/Assistant/AssistantActionTypes';
import AssistantStepTip from '../../Common/AssistantStepTip/AssistantStepTip';
import {
  AssistantAssetsProps,
  AssistantCommonProps,
  AssistantNavigationProps,
} from '../../Assistant';

type SmartSelectionStepProps = {
  startSmartDesign: (dryRun: boolean) => Promise<any>;
  setLoadingDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setWaitingDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
} & AssistantCommonProps &
  AssistantAssetsProps &
  AssistantNavigationProps;

export const SmartSelectionStep = ({
  assets,
  onClose,
  backButton,
  mediaGalleryProps,
  displayMode,
  startSmartDesign,
  setLoadingDialogOpen,
  setWaitingDialogOpen,
  ...props
}: SmartSelectionStepProps) => {
  const assistant = useAssistant();
  const [helpTipOpen, setHelpTipOpen] = useState<boolean>(false);

  useEffect(() => {
    setHelpTipOpen(true);
  }, []);

  const getNextButton = useCallback(() => {
    return cloneElement(props.nextButton, {
      ...props.nextButton.props,
      disabled: (() => {
        return 0 === assistant.state.selectedAssets.length;
      })(),
      onClick: () => {
        startSmartDesign(false).then(() => {
          setLoadingDialogOpen(false);
          setWaitingDialogOpen(false);
          props.nextButton.props.onClick();
        });
      },
    });
  }, [assistant.state.selectedAssets.length]);

  const helpTip = (
    <AssistantStepTip
      title={t('assistants:str_TitleSmartPictureSelection')}
      message={t('assistants:str_MessageSmartSelectionStep')}
      open={helpTipOpen}
      onClose={() => setHelpTipOpen(false)}
      key={'smart-selection-helptip'}
      nextFocusContainerId={'assistant-content'}
    />
  );

  const nextButton = getNextButton();

  return (
    <>
      <AssistantHeader displayMode={displayMode} onContinueInEditor={() => {}} />
      <AssistantNav
        onClose={onClose}
        backButton={backButton}
        nextButton={nextButton}
        onNext={nextButton.props.onClick}
      />
      <AssistantSubHeader
        assetCount={assets.length}
        minSelection={1}
        selectedAssetsCount={assistant.state.selectedAssets.length}
        showAddPicturesButton={false}
      />
      <AssistantContent className={'lg:p-lg sm:p-sm'}>
        {helpTip}
        <MediaGallery
          {...mediaGalleryProps}
          selectedImages={assistant.state.selectedAssets}
          onSelectPicture={(checked, asset) => {
            if (checked) {
              assistant.dispatch(AssistantActions.setSelectedAssets([asset.id], false));
            } else {
              assistant.dispatch(AssistantActions.removeSelectedAssets([asset.id]));
            }
          }}
        />
      </AssistantContent>
      <AssistantFooter />
    </>
  );
};
